"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCheckCurrentOnCheckedAmount = exports.handleRefreshMainPage = exports.handleRefreshSearchPage = exports.handleClickExpand = void 0;
const types_1 = require("../model/types");
const modalUtils_1 = require("./modalUtils");
/**
 * 處理 board 開合
 * @param setPageRoutes
 * @param currentPageRoutes
 * @param target
 */
const handleClickExpand = (setPageRoutes, currentPageRoutes, target) => {
    if (target)
        setPageRoutes(Object.assign(Object.assign({}, currentPageRoutes), { [target]: Object.assign(Object.assign({}, currentPageRoutes[target]), { isExpand: !currentPageRoutes[target].isExpand }) }));
};
exports.handleClickExpand = handleClickExpand;
/**
 * 查詢成功時，關閉 pageButtonGroup 、查詢表單、顯示查詢列表
 * @param setPageRoutes
 * @param initPageRoutes
 */
const handleRefreshSearchPage = (setPageRoutes, initPageRoutes, isRemainOpenSearchFrom = 'collapseSearchForm') => {
    setPageRoutes((PageRoutes) => {
        const isExpandSearchForm = isRemainOpenSearchFrom === 'remainSearchForm';
        return Object.assign(Object.assign({}, initPageRoutes), { pageButtonGroup: Object.assign(Object.assign({}, initPageRoutes.pageButtonGroup), { isExpand: false }), searchForm: Object.assign(Object.assign({}, PageRoutes.searchForm), { 
                // ...(isExpandSearchForm
                //     ? { isExpand: true }
                //     : { isExpand: (PageRoutes.searchForm as BlockStatus).isExpand }),
                isExpand: isExpandSearchForm, isDisplay: true }), searchResult: Object.assign(Object.assign({}, PageRoutes.searchResult), { isDisplay: true }) });
    });
};
exports.handleRefreshSearchPage = handleRefreshSearchPage;
/**
 * 主畫面重新整理，剛進到作業時的顯示
 * @param setPageRoutes
 * @param initPageRoutes
 */
const handleRefreshMainPage = (setPageRoutes, initPageRoutes) => {
    setPageRoutes(Object.assign(Object.assign({}, initPageRoutes), { searchForm: {
            isDisplay: true,
            isExpand: true
        } }));
};
exports.handleRefreshMainPage = handleRefreshMainPage;
const handleCheckCurrentOnCheckedAmount = (currentOnCheckedAmount, amountThreshold, dispatch) => {
    let isCheckPass = true;
    if (currentOnCheckedAmount < amountThreshold) {
        dispatch((0, modalUtils_1.openStatusModal)(types_1.StatusModalTypes.WARNING, `請至少勾選 ${amountThreshold} 筆`));
        isCheckPass = false;
    }
    return isCheckPass;
};
exports.handleCheckCurrentOnCheckedAmount = handleCheckCurrentOnCheckedAmount;
